/**
 * TimeFilter Component
 * 
 * "How much time do you have?" filter section with pill button options.
 * Options: 5, 10, 15, 30 (minutes)
 */

import { useFilter, TimeOption } from '../../../contexts/FilterContext';
import FilterSection from './FilterSection';
import FilterPillButton from './FilterPillButton';

// Available time options (in minutes)
const TIME_OPTIONS: TimeOption[] = [5, 10, 15, 30];

/**
 * Format time option for display
 */
function formatTimeLabel(minutes: number): string {
  return `${minutes} MIN`;
}

export default function TimeFilter() {
  const { filters, setTimeMinutes } = useFilter();

  const handleSelect = (time: TimeOption) => {
    // Toggle: if already selected, deselect; otherwise select
    if (filters.timeMinutes === time) {
      setTimeMinutes(null);
    } else {
      setTimeMinutes(time);
    }
  };

  return (
    <FilterSection title="How much time do you have?">
      <div className="flex flex-wrap gap-2">
        {TIME_OPTIONS.map((option) => (
          <FilterPillButton
            key={option}
            label={formatTimeLabel(option)}
            isSelected={filters.timeMinutes === option}
            onClick={() => handleSelect(option)}
          />
        ))}
      </div>
    </FilterSection>
  );
}
